import React, { Component } from "react";
import { MpaButton } from "./button";
import { MpaSlider } from "./slider";
import { MpaSwitch } from "./switch";
import { MpaSelector } from "./selector";

class Widget extends Component {
  constructor(props) {
    super(props);
    this.socket = props.socket;
    this.state = {
      type: props.meta.widget.type
    };
  }

  socket;

  componentDidMount() {
    /* The "rx" topic is for widget specific communication. Set up a handler to listen to data on the "rx" channel*/
    this.socket.on("rx", data => {
      if (this.props.meta.widget.name === data.name) {
        /* Filter the type of data coming from the server for a widgetevent where the type is TYPECHANGE */
        if (data.kind === "widgetevent" && data.type === "TYPECHANGE") {
          /* update the type of the widget in the state variable. This will trigger the render() function to be called */
          this.setState({ type: data.val });
          window.location.reload(true);
        }
      }
    });
  }

  /* Based on the metadata characteristics of the widget data received from the server,
   * spawn different MPA Widget Interface Components*/
  widgetForMeta = m => {
    const { identifier } = this.props;
    const { widget: w } = m;
    if (this.state.type === "BUTTON") {
      return (
        <div className="box">
          <MpaButton
            key={this.widgetIdentifier(identifier, w.idx, this.state.type)}
            identifier={this.widgetIdentifier(
              identifier,
              w.idx,
              this.state.type
            )}
            meta={m}
            socket={this.socket}
          ></MpaButton>
        </div>
      );
    } else if (this.state.type.startsWith("SLIDER")) {
      return (
        <div className="box">
          <MpaSlider
            key={w.name}
            identifier={w.name}
            meta={m}
            socket={this.socket}
            orientation={this.state.type.split("_")[1]}
          ></MpaSlider>
        </div>
      );
    } else if (this.state.type === "TOGGLE") {
      return (
        <div className="box">
          <MpaSwitch
            key={w.name}
            identifier={w.name}
            meta={m}
            socket={this.socket}
          ></MpaSwitch>
        </div>
      );
    } else if (this.state.type.startsWith("SELECTOR")) {
      return (
        <div className="box">
          <MpaSelector
            key={w.name}
            identifier={w.name}
            meta={m}
            socket={this.socket}
            orientation={this.state.type.split("_")[1]}
          ></MpaSelector>
        </div>
      );
    } else if (this.state.type === "EMPTY") {
      return <div className="box"></div>;
    } else {
      return <React.Fragment></React.Fragment>;
    }
  };

  /* Every component in react must have a unique identifier.
   * Use this function to do this. */
  widgetIdentifier = (row, index, widget) => {
    return row + "-" + widget + "-" + index;
  };

  render() {
    const { meta } = this.props;
    return this.widgetForMeta(meta);
  }
}

export default Widget;
